module.exports = __webpack_public_path__ + "img/decoration.4057192a.png";